import axiosClient from './axiosClient';
import { RaciMatrixEntry, AuditLog, PagedResponse } from '@/types/common';

export interface AuditLogFilters {
  page?: number;
  size?: number;
  entityType?: string;
  action?: string;
  username?: string;
  startDate?: string;
  endDate?: string;
}

export const adminApi = {
  // RACI Matrix
  getRaciMatrix: async (): Promise<RaciMatrixEntry[]> => {
    const response = await axiosClient.get('/raci-matrix');
    return response.data;
  },

  updateRaciMatrix: async (entries: RaciMatrixEntry[]): Promise<RaciMatrixEntry[]> => {
    const response = await axiosClient.put('/raci-matrix', entries);
    return response.data;
  },

  // Audit Log
  getAuditLog: async (params?: AuditLogFilters): Promise<PagedResponse<AuditLog>> => {
    const response = await axiosClient.get('/activity/audit-log', { params });
    return response.data;
  },

  // Enum lookups
  getRoles: async (): Promise<string[]> => {
    const response = await axiosClient.get('/admin/roles');
    return response.data;
  },

  getPhases: async (): Promise<{ name: string; displayName: string; gateLabel: string }[]> => {
    const response = await axiosClient.get('/admin/phases');
    return response.data;
  },

  getRaciTypes: async (): Promise<string[]> => {
    const response = await axiosClient.get('/admin/raci-types');
    return response.data;
  },
};
